import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { mcpChatTranslationRef } from '../../translation';

interface QuickStartProps {
  onSuggestionClick: (suggestion: string) => void;
  compact?: boolean;
}

export const QuickStart: React.FC<QuickStartProps> = ({ compact = false }) => {
  const theme = useTheme();
  const { t } = useTranslationRef(mcpChatTranslationRef);
  return (
    <Box
      sx={{
        padding: compact ? 0 : theme.spacing(3, 3),
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflowY: 'auto',
        ...(compact && {
          position: 'absolute',
          bottom: '105px',
          left: '50%',
          width: '235px',
          height: '26px',
          transform: 'translateX(-50%)',
          overflow: 'visible',
        }),
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: compact ? 400 : 500,
          marginBottom: compact ? 0 : theme.spacing(2),
          color: theme.palette.mode === 'dark' ? '#FFF' : '#000',
          fontSize: compact ? '16px' : '2.5rem',
          lineHeight: compact ? '30px' : '130%',
          maxWidth: compact ? '235px' : '380px',
          width: compact ? '235px' : undefined,
          height: compact ? '26px' : undefined,
          textAlign: compact ? 'justify' : 'center',
          fontStyle: 'normal',
          margin: '0 auto',
        }}
      >
        {t('quickStart.heading')}
      </Typography>
    </Box>
  );
};
